const apiBasePath = '/umbraco/surface/WishlistSurface/';

const fetchBaseConfig: RequestInit = {
  credentials: 'same-origin',
  headers: {
    'content-type': 'application/json',
    accept: 'application/json',
  },
};

export const addItemToSaveForLater = (
  catalogueRef: string | null,
  modifier: string | null,
  quantity: number
) => {
  const path = `${apiBasePath}AddItemToSaveForLater`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      catalogueRef,
      modifier,
      quantity
    }),
  }).then(response => response.json());
};

export const removeItemFromSaveForLater = (catalogueRef: string | null) => {
  const path = `${apiBasePath}RemoveFromSaveForLater`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      catalogueRef
    }),
  }).then(response => response.json());
};

export const checkItemInSaveForLater = (catalogueRef: string) => {
  const path = `${apiBasePath}CheckItemInSaveForLater`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      catalogueRef
    }),
  }).then(response => response.json());
};

export const updateSavedForLaterItemQuantity = (catalogueRef: string, quantity: number) => {
  const path = `${apiBasePath}UpdateSavedForLaterItemQuantity`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      catalogueRef,
      quantity
    }),
  }).then(response => response.json());
};

export const addSavedForLaterItemsToBasket  = () => {
  const path = `${apiBasePath}AddSavedForLaterItemsToBasket`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST'
  }).then(response => response.json());
};
